export enum HighlightedType {
  Recommended = 'recommended',
  Personalised = 'personalised',
  Cheapest = 'cheapest',
  Fastest = 'fastest',
  Earliest = 'earliest',
  WithBaggage = 'withBaggage',
  MetaSelection = 'metaSelection',
  DealWeekend = 'deal.weekend',
  DealHottest = 'deal.hottest',
  Default = 'default',
  PrimeDay = 'primeDay',
  FlightOfTheDay = 'flightOfTheDay',
}

type HighlightedTypeKeyMap = {
  [key in HighlightedType]: {
    type: string;
    size: string;
    backgroundColor?: string;
    color?: string;
    padding?: string;
    border?: string;
    marginBottom?: string;
  };
};

export const highlightedTypesKeyMap: HighlightedTypeKeyMap = {
  [HighlightedType.Recommended]: {
    type: 'positive',
    size: 'full',
  },
  [HighlightedType.Personalised]: {
    type: 'branded',
    size: 'full',
  },
  [HighlightedType.Cheapest]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.Fastest]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.Earliest]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.WithBaggage]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.MetaSelection]: {
    type: 'branded',
    size: 'full',
  },
  [HighlightedType.DealHottest]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.DealWeekend]: {
    type: 'positive',
    size: 'small',
  },
  [HighlightedType.Default]: {
    type: 'positive',
    size: 'full',
  },
  [HighlightedType.PrimeDay]: {
    type: 'promotional',
    size: 'full',
  },
  [HighlightedType.FlightOfTheDay]: {
    type: 'positive',
    size: 'full',
    backgroundColor: 'positive.20',
    color: 'positive.70',
    padding: 'base',
    border: '0',
    marginBottom: 'minus_small',
  },
} as const;
